import { render } from "./pledge-count.vue?vue&type=template&id=754678f8&scoped=true"
import script from "./pledge-count.vue?vue&type=script&lang=js"
export * from "./pledge-count.vue?vue&type=script&lang=js"

import "./pledge-count.vue?vue&type=style&index=0&id=754678f8&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754678f8"]])

export default __exports__